var React = require('react');

function NoChange (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5v2H0V5h12z","fill":"currentColor"}));
}

NoChange.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = NoChange;

NoChange.default = NoChange;
